// src/services/configuracionTextoApi.js
// Cliente para /api/ecolab/configuracion-texto (T&C, políticas, etc.)

const BASE = process.env.REACT_APP_API_URL || 'http://localhost:5246';

function tok() { return localStorage.getItem('ecolab_token') || null; }

async function apiGet(path, { auth = false } = {}) {
  const headers = { 'Content-Type': 'application/json' };
  if (auth && tok()) headers.Authorization = `Bearer ${tok()}`;
  const res = await fetch(`${BASE}${path}`, { headers });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw Object.assign(new Error(data.mensaje || `GET ${path} → ${res.status}`), { data, status: res.status });
  return data;
}

async function apiSend(method, path, body, { auth = false } = {}) {
  const headers = { 'Content-Type': 'application/json' };
  if (auth && tok()) headers.Authorization = `Bearer ${tok()}`;
  const res = await fetch(`${BASE}${path}`, {
    method, headers,
    body: body === undefined ? undefined : JSON.stringify(body),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw Object.assign(new Error(data.mensaje || `${method} ${path} → ${res.status}`), { data, status: res.status });
  return data;
}

// Público — para el wizard
export const getConfiguracionTexto = (clave) =>
  apiGet(`/api/ecolab/configuracion-texto/${encodeURIComponent(clave)}`);

// Admin
export const actualizarConfiguracionTexto = (clave, { titulo, contenido }) =>
  apiSend('PUT', `/api/ecolab/configuracion-texto/${encodeURIComponent(clave)}`,
          { titulo, contenido }, { auth: true });

export const getHistorialConfiguracionTexto = (clave) =>
  apiGet(`/api/ecolab/configuracion-texto/${encodeURIComponent(clave)}/historial`, { auth: true });

export const getHistorialItemConfiguracionTexto = (id) =>
  apiGet(`/api/ecolab/configuracion-texto/historial/${id}`, { auth: true });
